import { computed } from 'vue'
import store from '@/store'

export function useMostrarPreventa(event) {
    const userComputed = computed(() => store.getters.getUser)

    const mostrarBotonesPreventa = computed(() => {
        const p = event?.value?.preventa
        if (!p) return false

        const userRegistrado = userComputed.value && p.registrado_en_preventa

        if (!p.preventa_activa) return false

        if (!(p.venta_preventa_activa || p.registro_preventa_activo)) return false

        if (p.comprado_en_preventa && p.registrado_en_preventa) return false

        if (p.venta_preventa_activa) {
            if (!p.registro_preventa_activo) {
                if (!userRegistrado) return false
                if (!p.puede_comprar_en_preventa) return false
            }
        }

        return true
    })

    return {
        mostrarBotonesPreventa
    }
}